import { getToken } from "@/setup/api";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("membersSetup", ["setup"]),
    hasConfig() {
      return !!this.setup && !!this.setup.name && !!this.setup.subdomain;
    },
    membersURL() {
      return `https://${
        this.setup?.subdomain
      }.zeusmembers.club/token?token=${getToken()}`;
    }
  },
  methods: {
    getMemberAreaSetup() {
      this.$store.dispatch("membersSetup/get", this.$route.params.id).then();
    },
    openClubLogged() {
      window.open(
        `https://${
          this.setup.subdomain
        }.zeusmembers.club/token?token=${getToken()}`,
        "_blank"
      );
    }
  }
};
